import * as types from './generalActionTypes.js';

export const setTimers = (timers) => ({ type: types.SET_TIMERS, timers: timers });
export const setSilos = (silos) => ({ type: types.SET_SILOS, silos: silos });
export const setBreakdownDetectedDialogOpen = (breakdownDetectedDialogOpen) => ({ type: types.SET_BREAKDOWNDETECTEDDIALOGOPEN, breakdownDetectedDialogOpen: breakdownDetectedDialogOpen });
export const setStoppedLine = (stoppedLine) => ({ type: types.SET_STOPPEDLINE, stoppedLine: stoppedLine });
export const setNotificationsCounter = (notificationsCounter) => ({ type: types.SET_COUNTER, notificationsCounter: notificationsCounter });
export const setHelpFilesDialogOpen = (helpFilesDialogOpen) => ({ type: types.SET_HELPFILESDIALOGOPEN, helpFilesDialogOpen: helpFilesDialogOpen });
export const setScaleData = (scaleData) => ({ type: types.SET_SCALEDATA, scaleData: scaleData });
export const setSystemParameters = (systemParameters) => ({ type: types.SET_SYSTEMPARAMETERS, systemParameters: systemParameters });

